import { Stack, Button, Box, Tooltip, IconButton, List, ListItem, ListItemText, ListItemButton } from '@mui/material';

import NoteAddIcon from '@mui/icons-material/NoteAdd'; // or any other relevant "new" icon
import SearchIcon from '@mui/icons-material/Search';
import AssignmentIcon from '@mui/icons-material/Assignment';


import { BasicTextFilterForm } from 'components/ui/BasicTextFilterForm';
import { FormDialog } from 'components/ui/FormDialog';
import { IBilling } from 'features/finance/models/Billing';
import { ITellerOperation } from 'features/finance/models/TellerOperation';
//import { IGroupBilling } from 'features/finance/models/GroupBilling';
import { useBasicFilterBilling } from 'features/finance/services/Billing';
import { useBasicFilterTellerOperation } from 'features/finance/services/TellerOperation';
import { IRegistration } from 'features/production/models/Registration';
import { useBasicFilterRegistration } from 'features/production/services/Registration';
import { ISchoolYearClassTemplate } from 'features/setup/models/SchoolYear';
import { useBasicFilterSchoolYearClassTemplate } from 'features/setup/services/SchoolYear';
//import { useBasicFilterGroupBilling } from 'features/finance/services/GroupBilling';
import { currentUserSessionAtom } from 'library/store';
import { MouseEvent, MouseEventHandler, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

export const QuickActions = () => {

    const { t, i18n } = useTranslation();
    const { language: lg, roleEntities, applicationSetup } = useRecoilValue(currentUserSessionAtom);

    const navigate = useNavigate();




    const [openBillingFilter, setOpenBillingFilter] = useState(false);
    const basicFilterBilling = useBasicFilterBilling(
        (event: React.MouseEvent<unknown>, row: IBilling) => {
            //   const {id, customerName, description, showroomName, amount, currencyCode } = row;

            //   navigate(`/sale/${id}`);                       
            //   setOpenBillingFilter(false);
        }
    );


    const [openRegistrationFilter, setOpenRegistrationFilter] = useState(false);
    const basicFilterRegistration = useBasicFilterRegistration(
        (event: React.MouseEvent<unknown>, row: IRegistration) => {
            const { id, } = row;

            navigate(`/registration/${id}`);
            setOpenRegistrationFilter(false);
        }
    );

    const [openTellerOperationFilter, setOpenTellerOperationFilter] = useState(false);
    const basicFilterTellerOperation = useBasicFilterTellerOperation(
        (event: React.MouseEvent<unknown>, row: ITellerOperation) => {
            const { id, } = row;

            navigate(`/tellerOperation/${id}`);
            setOpenTellerOperationFilter(false);
        }
    );

    const refSchoolYearId = useRef<number>(0);
    const [openSchoolYearClassTemplateFilter, setOpenSchoolYearClassTemplateFilter] = useState(false);
    const basicFilterSchoolYearClassTemplate = useBasicFilterSchoolYearClassTemplate(
        (event: React.MouseEvent<unknown>, row: ISchoolYearClassTemplate) => {
            const { id, } = row;

            navigate(`/schoolYearClassTemplate/${id}`);
            setOpenSchoolYearClassTemplateFilter(false);
        }, refSchoolYearId, true
    );

    const handleRegistration = async () => {
        //event.preventDefault();
        navigate('/registration/-999');
    }

    const handleRegistrationSearch = async () => {
        //event.preventDefault();
        setOpenRegistrationFilter(true);
    }

    const handleTellerOperation = async () => {
        //event.preventDefault();
        navigate('/tellerOperation/-999');
    }

    const handleTellerOperationSearch = async () => {
        //event.preventDefault();
        setOpenTellerOperationFilter(true);
    }

    // const handlePreRegistrations = async (event : MouseEvent<HTMLButtonElement>) => {

    //   event.preventDefault();
    //   setOpenSchoolYearClassTemplateFilter(true);  
    // }

    const handlePreRegistrations = async () => {
        //event.preventDefault();
        navigate('/preRegistrations/-999');
    }

    const handleSchoolYearClassSubjectMark = async () => {
        //event.preventDefault();
        navigate('/classExamMark/-999');
    }

    useEffect(() => {
        refSchoolYearId.current = applicationSetup.currentSchoolYearId;
    }, []);


    return (
        <List sx={{ p: 0, '& .MuiListItemButton-root': { transition: 'all 200ms ease', borderRadius: 1.2, my: 0.75, py: 1.2, px: 1.5, '&:hover': { backgroundColor: 'action.hover', transform: 'translateX(4px)', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }, '& .MuiSvgIcon-root': { fontSize: 24, opacity: 0.75 }, '& .MuiListItemText-primary': { fontWeight: 600, fontSize: '0.95rem', color: '#1a1a1a' } } }}>
            {roleEntities.some((re) => re.entityName === "Registration") && (
                <Tooltip title={t("List of pre-registrations")}>
                    <ListItemButton onClick={handlePreRegistrations}>
                        <NoteAddIcon sx={{ mr: 1.5 }} />
                        <ListItemText primary={`${t('Pre-registration')}(s)`} />
                    </ListItemButton>
                </Tooltip>
            )}

            {roleEntities.some((re) => re.entityName === "Registration") && (
                <Tooltip title={t("New registration")}>
                    <ListItemButton onClick={handleRegistration}>
                        <NoteAddIcon sx={{ mr: 1.5 }} />
                        <ListItemText primary={t("Registration")} />
                    </ListItemButton>
                </Tooltip>
            )}

            {roleEntities.some((re) => re.entityName === "Registration") && (
                <Tooltip title={t("Search registration")}>
                    <ListItemButton onClick={handleRegistrationSearch}>
                        <SearchIcon sx={{ mr: 1.5 }} />
                        <ListItemText primary={t("Search registration")} />
                    </ListItemButton>
                </Tooltip>
            )}

            {roleEntities.some((re) => re.entityName === "TellerOperation") && (
                <Tooltip title={t("New teller operation")}>
                    <ListItemButton onClick={handleTellerOperation}>
                        <NoteAddIcon sx={{ mr: 1.5 }} />
                        <ListItemText primary={t("Teller operation")} />
                    </ListItemButton>
                </Tooltip>
            )}

            {roleEntities.some((re) => re.entityName === "TellerOperation") && (
                <Tooltip title={t("Search teller operation")}>
                    <ListItemButton onClick={handleTellerOperationSearch}>
                        <SearchIcon sx={{ mr: 1.5 }} />
                        <ListItemText primary={t("Search teller operation")} />
                    </ListItemButton>
                </Tooltip>
            )}

            {roleEntities.some((re) => re.entityName === "SchoolYearClassSubjectMark") && (
                <Tooltip title={t("Mark of exam")}>
                    <ListItemButton onClick={handleSchoolYearClassSubjectMark}>
                        <NoteAddIcon sx={{ mr: 1.5 }} />
                        <ListItemText primary={t("Mark of exam")} />
                    </ListItemButton>
                </Tooltip>
            )}
            {/* <Button variant="outlined">Submit Claim</Button> */}

            {openRegistrationFilter && <FormDialog open={openRegistrationFilter} maxWidth='md'
                okText='' cancelText='' title={`${t('Registration')}(s)`} onCancel={() => { }}
                onClose={() => { setOpenRegistrationFilter(false); }} onOk={() => { setOpenRegistrationFilter(false); }}  >
                <BasicTextFilterForm<IRegistration> {...basicFilterRegistration} />
            </FormDialog>}
            {openTellerOperationFilter && <FormDialog open={openTellerOperationFilter} maxWidth='md'
                okText='' cancelText='' title={t('TellerOperation')} onCancel={() => { }}
                onClose={() => { setOpenTellerOperationFilter(false); }} onOk={() => { setOpenTellerOperationFilter(false); }}  >
                <BasicTextFilterForm<ITellerOperation> {...basicFilterTellerOperation} />
            </FormDialog>}
            {openSchoolYearClassTemplateFilter && <FormDialog open={openSchoolYearClassTemplateFilter} maxWidth='md'
                okText='' cancelText='' title={t('Classes')} onCancel={() => { }}
                onClose={() => { setOpenSchoolYearClassTemplateFilter(false); }} onOk={() => { setOpenSchoolYearClassTemplateFilter(false); }}  >
                <BasicTextFilterForm<ISchoolYearClassTemplate> {...basicFilterSchoolYearClassTemplate} />
            </FormDialog>}
        </List>
    );

}